import { useAppRole } from "../../../common/layout/v2/useAppRole";
import { useSub } from "../../../common/subscription/useSub";
import { filterHomeConfig, homeConfig } from "./homeConfig";
import { HomeShell } from "./HomeShell";

export const Home = () => {
  const role = useAppRole();
  const sub = useSub();
  return <HomeShell config={filterHomeConfig(homeConfig[role], sub)} />;
};
